import apis from '../apis/apis'

const vanBangProcessor = {}
const controllerName = 'VanBang'

vanBangProcessor.getById = async (id) => {
  const rs = await apis[controllerName].Get({
    param: id,
  })
  return rs.isSuccess ? rs.data : {}
}
vanBangProcessor.getByKhoaThi = async ({
  khoaThiId,
  skip,
  take,
  donViDangKyDuThiId = 0,
  heDaoTaoId = 0,
  hinhThucDaoTaoId = 0,
  name = '',
}) => {
  const rs = await apis[controllerName].GetVanBangDaDuyetByKhoaThiId({
    param: `/${khoaThiId}?skip=${skip}&take=${take}&donViDangKyDuThiId=${donViDangKyDuThiId}&heDaoTaoId=${heDaoTaoId}&hinhThucDaoTaoId=${hinhThucDaoTaoId}&name=${name}`,
  })
  return rs.isSuccess ? rs.data : { skip, take, values: [], total: 0 }
}
vanBangProcessor.export = async ({ truongId, khoaThiId }) => {
  const rs = await apis[controllerName].ExportVanBangDaDuyetByKhoaThiId({
    param: `?khoaThiId=${khoaThiId}&truongId=${truongId}`,
  })
  return rs.isSuccess ? rs.data : []
}

export default vanBangProcessor
